const mobileToggle = document.querySelector('.custom-mobile-toggle');
const mobileMenu = document.querySelector('.custom-mobile-menu');
const mobileClose = document.querySelector('.custom-mobile-menu__close');
const mobileOverlay = document.querySelector('.custom-mobile-menu__overlay');

function openMobileMenu() {
  if (mobileMenu && !document.body.contains(mobileMenu)) {
    document.body.appendChild(mobileMenu);
  }

  mobileMenu.classList.add('custom-mobile-menu--open');
  document.body.style.overflow = 'hidden';
}

function closeMobileMenu() {
  mobileMenu.classList.remove('custom-mobile-menu--open');
  document.body.style.overflow = '';
}

if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeMobileMenu();
  }
});

document.querySelectorAll('.custom-mobile-nav__toggle').forEach(toggle => {
  toggle.addEventListener('click', () => {
    const content = toggle.nextElementSibling;
    const isOpen = content.style.display === 'block';

    document.querySelectorAll('.custom-mobile-accordion__content').forEach(c => {
      c.style.display = 'none';
      c.previousElementSibling.classList.remove('custom-mobile-nav__toggle--open');
    });

    if (!isOpen) {
      content.style.display = 'block';
      toggle.classList.add('custom-mobile-nav__toggle--open');
    }
  });
});

document.querySelectorAll('.custom-mobile-subnav__toggle').forEach(toggle => {
  toggle.addEventListener('click', () => {
    const content = toggle.nextElementSibling;
    const isOpen = content.style.display === 'block';
    content.style.display = isOpen ? 'none' : 'block';
    toggle.classList.toggle('custom-mobile-subnav__toggle--open');
  });
});